import { selectUserSettingsValue } from "~/state/user/selectors";
import { ESETTINGS_KEYS } from "~/state/user/interfaces";
import { store } from "~/state/store";
import Scene from "~/scene";
import { isSaturationMapset } from "~/util/mapset";
import { setDesaturate } from "~/state/map/state";

const dimmLayer = Scene.createLayerMarker();

export function setDimmLayer(show = false, shadowLayer = false) {
	if (selectUserSettingsValue(store.getState(), ESETTINGS_KEYS.SEARCH_MAP_SUPPRESSION) && show) {
		Scene.addLayer(dimmLayer, true);

		dimmLayer.getShadowContainer(cont => {
			if (cont) {
				cont.classList[shadowLayer ? "add" : "remove"]("tile-dimm-layer");
			}
		});
		dimmLayer.getContainer(cont => {
			if (cont) {
				cont.classList[shadowLayer ? "remove" : "add"]("tile-dimm-layer");
			}
		});
	} else {
		Scene.removeLayer(dimmLayer);
	}
}

export function setSaturation(on = false) {
	const state = store.getState().map;
	const turnOn = on && isSaturationMapset(state);

	if (selectUserSettingsValue(store.getState(), ESETTINGS_KEYS.SEARCH_MAP_SUPPRESSION)) {
		Mapy.getComponent("layout").setClassOnMapElement("saturation", turnOn);
		store.dispatch(setDesaturate(turnOn));
	} else {
		store.dispatch(setDesaturate(false));
	}
}
